import { Row, Col } from 'reactstrap';
import { css } from '@emotion/react';
import PropTypes from 'prop-types';

import NumberInput from 'common/components/form/inputs/NumberInput';

const RequestedValue = ({
  changeField,
  fields,
  showHeader,
  isDateJoined = false,
  isEditDisabled
}) => {
  return (
    <Row className="flex-nowrap" noGutters>
      <Col
        xs="auto"
        className={`fw-medium fs-12 text-primary cmt-4 cpe-12 ${isDateJoined ? 'opacity-0' : ''}`}
      >
        shall not be less than
      </Col>

      <Col xs={4} className="position-relative">
        {showHeader ? (
          <div
            className="fw-bold text-violet fs-12"
            css={css`
              position: absolute;
              bottom: ${fields.threshold?.error ? '55px' : '47px'};
            `}
          >
            Req. Value
          </div>
        ) : null}

        <NumberInput
          fixedDecimalScale={2}
          disabled={isEditDisabled}
          className={`${fields.threshold?.error ? 'mb-1' : 'mb-0'}`}
          onChange={changeField('threshold')}
          allowNegative={false}
          {...fields.threshold}
        />
      </Col>

      <Col className="fw-medium fs-12 text-primary cps-12 cmt-4 text-nowrap">
        {isDateJoined ? 'days' : 'years'}
      </Col>
    </Row>
  );
};

export default RequestedValue;

RequestedValue.propTypes = {
  changeField: PropTypes.func.isRequired,
  isDateJoined: PropTypes.bool,
  showHeader: PropTypes.bool,
  isEditDisabled: PropTypes.bool,
  fields: PropTypes.shape({
    aggregation_type: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    rank: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    second_rank: PropTypes.shape({ value: PropTypes.object, error: PropTypes.string }),
    threshold: PropTypes.shape({ value: PropTypes.string, error: PropTypes.string }),
    type_id: PropTypes.shape({ value: PropTypes.number, error: PropTypes.string })
  })
};
